import { React } from "react";
import { CustomDiv } from "../chat-bot/style";
import { CommonGrid2 } from "../common-components/StyledComponents";
import { Typography } from "@mui/material";
import CommonTextField from "../../component/Input";
import CommonButton from "../../component/Button";
import { platformBlackLogo } from "../../utils/logo";
import {ReactComponent as DynamicIntelligenceHaileyIco} from "../../assets/images/dynamic-intelligence-hailey.svg";

function ExpiryScreen({ details, setDetails, loading, handleVerify, lg }) {
    return (
        <CustomDiv background={"#EBE1F9"}>
            <CommonGrid2
                display="flex"
                flexDirection="column"
                gap="1rem"
                sx={{
                    width: {
                        xs: "90%",
                        sm: "80%",
                        md: "400px",
                    }
                }}
                alignItems={"center"}
                justifyContent={"center"}
                height={"100vh"}
                customStyle={{ margin: "0 auto" }}
            >
                <CommonGrid2
                    background='#fff'
                    height={"max-content"}
                    width={"100%"}
                    borderRadius={"12px"}
                    display={"flex"}
                    gap={"1rem"}
                    flexDirection={"row"}
                >
                    <CustomDiv
                        height={"100%"}
                        padding={"10px 10px 0px 16px"}
                        display={"flex"}
                    >
                        <DynamicIntelligenceHaileyIco />
                    </CustomDiv>
                    <CommonGrid2
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"start"}
                    >
                        <Typography
                            variant={lg ? "h3" : "h3xs"}
                            fontWeight={"700"}
                            sx={{
                                background: "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                            }}
                        >Sorry, {details.name}</Typography>
                        <Typography
                            variant={ lg ? "h5" : "h5xs" }
                            color={"#5B738B"}
                            fontWeight={"400"}
                        >
                            Your time limit has expired. Please contact the manager to request access.
                        </Typography>
                    </CommonGrid2>
                </CommonGrid2>
                    {/* <CommonButton
                        value={"Request access"}
                        width={"100%"}
                        padding={"10px"}
                        fontWeight={"700"}
                        fontSize={"14px"}
                        borderRadius={"10px"}
                        onClick={handleVerify}
                        disabled={loading}
                        loading={loading}
                    /> */}

                {/* <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    customStyle={{ marginTop: "5rem" }}
                >
                    <Typography fontSize={"10px"} color={"#5B738B"} textAlign={"center"}>Powered by TalAiro</Typography>
                    <TalairoLogo height="40px" />
                </CommonGrid2> */}
            </CommonGrid2>
        </CustomDiv>
    );
}

export default ExpiryScreen;
